import { Paper, styled } from "@mui/material";
import { useTagsContext } from "hooks/routerHooks";
import { Branch } from "./Branch";

export default function LoadFilterOptions() {
  const { tags } = useTagsContext();
  const { treeTags } = tags;

  return (
    <StyledPaper elevation={0} data-tour="step-2">
      {treeTags.map((tag) => {
        return <Branch key={tag.id} tag={tag} />;
      })}
    </StyledPaper>
  );
}

const StyledPaper = styled(Paper)`
  background-color: ${({ theme }) => theme.palette.grey[100]};
  padding: ${({ theme }) => theme.spacing(0.5)};
  display: flex;
  flex-direction: column;
  overflow: auto;
  .MuiAccordion-root:last-child {
    border: none;
  }
`;
